import { Component, Inject } from '@angular/core';

import get from 'lodash/get';
import { Subscription } from 'rxjs';

import { ISitemap, SITEMAP } from 'pbc.angular';
import { ISelection } from 'pbc.types';

import { BewertungsAnlasssQueryFilterConfig, IBewertungsAnlasssQueryShapes } from 'fa-kt.types';
import { BewertungsAnlasssService } from '../service';

@Component({
  selector: 'fa-kt-bewertungs-anlasss-filter',
  templateUrl: './bewertungs-anlasss-filter.component.html',
  styleUrls: ['./bewertungs-anlasss-filter.component.css'],
})
export class BewertungsAnlasssFilterComponent {
  readonly subscriptions: Subscription[] = [];

  BewertungsAnlasssFilterConfig;

  constructor(
    @Inject(SITEMAP) private sitemap: ISitemap,
    public bewertungsAnlasss: BewertungsAnlasssService,
  ) {
    this.BewertungsAnlasssFilterConfig = BewertungsAnlasssQueryFilterConfig.map((filter) => ({ ...filter, title: get(sitemap, filter.title, filter.title) as string }));
    /* << update mapper    */
    /*    update mapper >> */
  }

  ngOnInit() {
    this.subscriptions.push(
      this.bewertungsAnlasss.shapes$.subscribe((shapes: IBewertungsAnlasssQueryShapes | undefined) => {
        if (!shapes) {
          return;
        }
        Object.entries(shapes)
          .filter(([key]) => key !== 'id' && (shapes as any)[key])
          .forEach(([key]) => this.shape(key, (shapes as any)[key]));
      }),
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(($) => $.unsubscribe());
  }

  private shape(field: string, shapes: ISelection[]): void {
    const index = this.BewertungsAnlasssFilterConfig.findIndex((f) => f.key === field);
    if (index < 0) {
      return;
    }
    this.BewertungsAnlasssFilterConfig[index].selections = shapes;
  }
}
